<template>
  <div
    v-if="visible"
    ref="popup"
    class="popup"
    :style="{ left: position.x + 'px', top: position.y + 'px' }"
    @mouseenter="onPopupEnter"
    @mouseleave="onPopupLeave"
  >
    <slot />
  </div>
</template>

<script>
export default {
  name: 'HoverPopup',
  data() {
    return {
      visible: false,
      position: { x: 0, y: 0 },
      isHoveringPopup: false,
      hideTimeout: null,
    };
  },
  methods: {
    show(x, y) {
      clearTimeout(this.hideTimeout);
      this.visible = true;
      this.$nextTick(() => this.adjustPosition(x, y));
    },
    updatePosition(x, y) {
      if (!this.visible) return;
      this.adjustPosition(x, y);
    },
    hide() {
      clearTimeout(this.hideTimeout);
      this.visible = false;
    },
    startHideDelay() {
      clearTimeout(this.hideTimeout);
      this.hideTimeout = setTimeout(() => {
        if (!this.isHoveringPopup) {
          this.hide();
        }
      }, 200); // delay before hiding to allow entering popup
    },
    onPopupEnter() {
      clearTimeout(this.hideTimeout);
      this.isHoveringPopup = true;
    },
    onPopupLeave() {
      this.isHoveringPopup = false;
      this.startHideDelay(); // hide again if mouse leaves popup
    },
    adjustPosition(x, y) {
      const offset = 10;
      this.$nextTick(() => {
        const popup = this.$refs.popup;
        if (!popup) return;

        const rect = popup.getBoundingClientRect();
        const screenW = window.innerWidth;
        const screenH = window.innerHeight;

        let left = x + offset;
        let top = y + offset;

        if (left + rect.width > screenW) left = x - rect.width - offset;
        if (top + rect.height > screenH) top = y - rect.height - offset;

        this.position = { x: left, y: top };
      });
    }
  }
};
</script>

<style scoped>
.popup {
  width: 378px;
  position: fixed;
  padding: 12px;
  border-radius: 4px;
  border: solid 1px #d5d5d6;
  background-color: #fff;
  z-index: 9999;
  pointer-events: auto;
}
</style>
